/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MembershipDtoPage } from '../../models/membership-dto-page';

export interface ListMemberships$Params {
  isGlobal?: boolean | null;
  projectId?: string | null;
  roleId?: string | null;
  memberId?: string | null;
  userId?: string | null;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'projectId' | '-projectId' | 'memberId' | '-memberId' | 'role' | '-role' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listMemberships(http: HttpClient, rootUrl: string, params?: ListMemberships$Params, context?: HttpContext): Observable<StrictHttpResponse<MembershipDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listMemberships.PATH, 'get');
  if (params) {
    rb.query('isGlobal', params.isGlobal, {});
    rb.query('projectId', params.projectId, {});
    rb.query('roleId', params.roleId, {});
    rb.query('memberId', params.memberId, {});
    rb.query('userId', params.userId, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MembershipDtoPage>;
    })
  );
}

listMemberships.PATH = '/v0/memberships';
